import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async markAsSeen() {
    await wrapEndpoint(() => client.PATCH('/user/onboard/mark-as-seen'))
  },
}
